<template>
    <div v-show="show">
        <div class="acclaro ui loader">
            <div>
                <img src="/images/logos/acclaro-logo-icon-only.png" alt="Acclaro" width="45" />
                <p>Loading, please wait <span style="width:20px;display:inline-block;text-align:left;">{{ dots }}</span></p>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '../../event-bus.js';

    export default {

        data() {
            return {
                dots: '.',
                show: false
            }
        },

        //creates dots animation
        methods: {
            updateDots() {
                if(this.dots === '.') {
                    this.dots = '..';
                } else if(this.dots === '..') {
                    this.dots = '...'
                } else {
                    this.dots = '.'
                }
                return
            },
        },

        mounted() {
            EventBus.$on('loader:hide', () => {
                this.show = false
            })

            EventBus.$on('loader:show', () => {
                this.show = true
            })

            setInterval(() => {
                this.updateDots()
            }, 500)
        }

    }
</script>
